<template>
  <div>
    <button v-if="session.is_admin" class="btn btn-success" id="show-modal" @click="showModal = true">Edit</button>
    <!-- use the modal component, pass in the prop -->
    <record-edit-modal v-if="showModal" @close="showModal = false">
      <!--
        you can use custom content here to overwrite
        default content
      -->
    </record-edit-modal>
  </div>
</template>

<script>
import RecordEditModal from "./RecordEditModal";
import { mapState } from "vuex";

export default {
  name: "record-edit-button",
  computed: mapState(["record", "session"]),
  components: { RecordEditModal },
  data: function() {
    return {
      showModal: false
    };
  }
};
</script>
